import styled from 'styled-components';
import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';

export const StyledText = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;

export const StyledTextButton = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;
